import { fromUnixTime, isPast } from 'date-fns';
import constants from './constants';
import { constants as otpConstants } from '../otp';
import { constants as appConstants } from '../app';

/**
 * @type {Object} The initial state.
 */
export const initialState = {
  id: null,
  name: null,
  emailAddress: null,
  verified: null,
  permissionGroups: [],
  roles: [],
};

/**
 * A reducer to modify the state.
 *
 * @param {Object} state The current state.
 * @param {string} type The action type.
 * @param {*} payload The action payload.
 *
 * @returns {Object} The updated state.
 */
export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    // Set the logged in user.
    case constants.login:
      return { ...state, ...payload.user };

    // Set the verified state for the logged in user.
    case constants.verify:
      return { ...state, verified: payload };

    // When the OTP is stored or destroyed, reset the verified state.
    case otpConstants.store:
    case otpConstants.destroy:
      return { ...state, verified: null };

    case appConstants.setSessionExpired:
    case constants.logout:
      return initialState;

    // The roles and the permission groups are scoped to the customer, so they go
    // with it rather than gating the picker on what was just closed.
    case constants.closeCustomer:
      return {
        ...state,
        roles: initialState.roles,
        permissionGroups: initialState.permissionGroups,
      };

    default: {
      // If the verified date has passed, modify the state.
      if (state.verified !== initialState.verified && isPast(fromUnixTime(state.verified))) {
        return { ...state, verified: initialState.verified };
      }

      // Return the current state.
      return state;
    }
  }
};
